export default "__VITE_ASSET__B_UFL1qu__"